<template>
	<div class="nk-control" @focus="onFocused" :tabindex="disabled ? false : tabindex">
		<textarea :placeholder="settings.placeholder" :startup="startup ? true : null" :disabled="disabled ? true : null" :maxlength="maxlength" :value="inputValue" @focus="onFocused" @input="onChanged" @blur="onBlur" :class="{ 'ltr': settings.ltr }" class="form-control form-control-sm" :rows="settings.rows" type="text" ref="input"></textarea>
	</div>
</template>
<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'

	export default {
		props: {
			options: { type: Object },
			modelValue: { type: [String, Number] },
			tabindex: { type: [String, Number, Boolean] },
			startup: { type: Boolean },
			disabled: { type: Boolean, default: false },
			required: { type: Boolean },
			maxlength: { type: Number },
			autocomplete: { type: Boolean },
			rows: { type: Number },
			small: { type: Boolean, default: false }
		},
		emits: ['update:modelValue', 'blur'],
		data() {
			return {
				settings: {
					placeholder: '',
					ltr: false,
					emitInitValue: false,
					rows: 5
				},
				pauseGetValue: false,
				pVal: '',
			}
		},
		computed: {
			isRequired() {
				if (this.settings.required || this.required) {
					return true
				}
				return false
			},
			input() {
				return this.$refs.input
			},
			inputValue: {
				get: function () {
					return String(this.pVal).toLocaleDigits()
				},
				set: function (val) {
					this.pVal = val
				}
			}
		},
		watch: {
			options: {
				handler(val) {
					this.cloneSettings(val)
				},
				deep: true
			},
			modelValue: {
				handler(val) {
					if (this.pauseGetValue === true) {
						this.pauseGetValue = false
						return
					}
					this.inputValue = val
				}
			}
		},
		created() {
		},
		mounted() {
			this.cloneSettings(this.options)
			this.inputValue = this.modelValue

			if (this.settings.emitInitValue) {
				this.defer(() => this.onChanged(), 10)
			}
		},
		methods: {
			cloneSettings(val) {
				this.settings = _.extend({}, this.settings, val)
				if (this.rows && this.rows > 0)
					this.settings.rows = this.rows
			},
			pureValue() {
				return String(this.input.value).toEnglishDigits()
			},
			onFocused() {
				if (!$(this.input).is(':focus')) {
					this.input.focus()
				}
				this.defer(() => {
					if ($(this.input).is(':focus')) {
						this.input.select()
					}
				}, 10)
			},
			onChanged() {
				let pureValue = this.pureValue()
				this.emit(pureValue)
			},
			onBlur() {
				this.$emit('blur')
			},

			emit(value) {
				this.pauseGetValue = true
				this.inputValue = value
				this.$emit('update:modelValue', value)
			},

			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'nikan-input-enter',
					shortcut: $sc.find('enter-only'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						if (e.target.selectionStart === 0 && e.target.selectionEnd <= $(this.input).val().length) return false
						return true
					}
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-shift-enter',
					shortcut: $sc.find('nextTab', 'textarea'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						return true
					}
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-cut',
					shortcut: $sc.find('cut', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						e.preventDefault()
						var selectedText = ""
						if (window.getSelection) {
							selectedText = window.getSelection().toString()
						}
						navigator.clipboard.writeText(selectedText)
						this.emit('')
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-up-arrow',
					shortcut: $sc.find('up', 'textarea'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						if (e.target.selectionStart != e.target.selectionEnd) return true
						if (this.settings.ltr)
							return e.target.selectionStart < $(this.input).val().length
						return e.target.selectionStart != 0
					}
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-down-arrow',
					shortcut: $sc.find('down', 'textarea'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						if (e.target.selectionStart != e.target.selectionEnd) return true
						if (this.settings.ltr) return e.target.selectionStart != 0
						return e.target.selectionStart < $(this.input).val().length
					}
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-selectAll',
					shortcut: $sc.find('selectAll', 'textarea'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						e.preventDefault()

						this.onFocused()

						return true
					}
				})
			}
		},
	}
</script>
<style></style>
